var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HdNotifications',{staticClass:"root-notifications",attrs:{"v-if":_vm.isVisible,"notifications":_vm.notifications},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var notification = ref.notification;
return [_c('NotificationItem',{attrs:{"notification":notification}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }